const faqs = [
  {
    q: '成全影院真的完全免费吗？',
    a: '是的，成全影院所有电影大全、电视剧全集、综艺大全最新影片资源均免费提供在线观看。我们通过优化运营成本，坚持为观众提供免费高清不卡顿的观影服务，无需注册、无需付费即可畅享全部内容。',
  },
  {
    q: '视频画质怎么样？会不会经常卡顿？',
    a: '成全影院默认提供1080P高清画质，部分热门影片支持4K超清。平台采用智能CDN加速和自适应码率技术，会根据您的网络状况自动优化播放质量，确保流畅不卡顿的观影体验。',
  },
  {
    q: '影片更新频率如何？多久能看到新内容？',
    a: '编辑团队全天候追踪影视动态，每日稳定更新30+部最新影片。热播剧和热映电影通常在上线后24小时内同步更新，综艺节目做到次日更新，确保您不会错过任何精彩。',
  },
  {
    q: '支持哪些设备观看？需要下载APP吗？',
    a: '成全影院完美适配手机、平板和电脑全终端，打开浏览器即可访问，无需下载任何APP或插件。网站采用响应式设计，在不同屏幕尺寸下都能获得良好的观影体验。',
  },
  {
    q: '有广告吗？观影体验如何？',
    a: '成全影院坚持绿色无弹窗广告的观影理念，观影过程中不会弹出任何干扰性广告。我们致力于为全年龄段观众提供纯净、安全、舒适的免费电影在线观看环境。',
  },
  {
    q: '如何找到想看的影片？支持搜索吗？',
    a: '您可以通过首页的主题索引、精选分类和热门排行快速定位感兴趣的内容。平台按电影大全、电视剧全集、综艺大全等分类整理，也可以通过热门话题发现大家都在看的好片。',
  },
];

export default function FaqSection() {
  return (
    <section id="faq" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-[1280px] mx-auto">
          <div className="text-center mb-10">
            <span className="inline-block px-3 py-1 text-xs font-medium text-primary-700 bg-primary-50 rounded-full mb-3 whitespace-nowrap">
              常见问题
            </span>
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900">
              常见问答
            </h2>
            <p className="mt-2 text-sm text-foreground-500 max-w-lg mx-auto">
              关于成全影院，你想知道的都在这里
            </p>
          </div>

          <div className="max-w-[800px] mx-auto grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-5">
            {faqs.map((faq, i) => (
              <article key={i} className="bg-background-50 rounded-xl p-5 border border-background-200/70">
                <h3 className="font-heading text-sm md:text-base font-semibold text-foreground-900 mb-2 flex items-start gap-2">
                  <span className="text-primary-500 flex-shrink-0 mt-0.5">
                    <i className="ri-question-answer-line w-4 h-4 flex items-center justify-center"></i>
                  </span>
                  {faq.q}
                </h3>
                <p className="text-sm text-foreground-600 leading-relaxed pl-6">{faq.a}</p>
              </article>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}